module.exports = __webpack_public_path__ + "static/media/backarrow.bfe8ade2.svg";